
import { defineComponent, reactive } from 'vue'
import type { PropType } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import ActionButton from '@/components/Shared/ActionButton.vue'
import ErrorMessage from '@/components/Shared/Form/ErrorMessage.vue'

export default defineComponent({
  components: {
    ActionButton,
    ErrorMessage
  },
  props: {
    slug: { type: String as PropType<string | null>, default: () => '' },
    submittable: { type: Boolean, default: true }
  },
  emits: ['submit'],
  setup(props) {
    const form = reactive({ slug: props.slug })
    const v$ = useVuelidate()

    return { form, v$ }
  },
  methods: {
    async submitHandler() {
      if (!this.submittable) return

      const isFormValid = await this.v$.$validate()
      if (isFormValid) this.$emit('submit', this.form.slug)
    }
  },
  validations() {
    return {
      form: {
        slug: { required }
      }
    }
  }
})
